import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(72px, 1fr))',
    gridGap: `${defaultTheme.spacing.l} 0`,
    margin: [
      `${defaultTheme.spacing.l} 0 ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.l} 0 ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.l} 0`,
    ],
  }),
);

export const WheelWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      'repeat(3, 1fr)',
      'repeat(3, 1fr)',
      'repeat(6, 1fr)',
      'repeat(6, 1fr)',
    ],
    gridGap: '4px 8px',
    gridTemplateRows: ['46px 46px', '46px 46px', '46px', '46px'],
    marginTop: [defaultTheme.spacing.l, defaultTheme.spacing.l, 0, 0],
  }),
);
